const beneficiosModule = {
    state() {
        return {
           
        };
    },

    mutations: {
 
    },

    actions: {
    },

    getters: {

    },
};

export default beneficiosModule;
